export default "__VITE_ASSET__g$Yh0jNS__"